import React, { Component } from "react";
import {
  InputGroup,
  FormControl,
  Button,
  FormGroup,
  FormLabel,
} from "react-bootstrap";

import classes from "./ButtonAddon.module.css";

interface Props {
  label: string;
  firstBtnLabel: string;
  secondBtnLabel: string;
  elementLabelStyle: {};
  elementInputStyle: {};
  name?: string;
  errorText?: string;
  value?: any;
  onChange?: (event) => void;
  onClickPlus?: (event) => void;
  onClickMinus?: (event) => void;
  disabled?: boolean;
  readOnly?: boolean;
  subtext?: string;
  maxVal?: number;
}

class ButtonAddon extends Component<Props> {
  render() {
    const {
      label,
      firstBtnLabel,
      secondBtnLabel,
      elementLabelStyle,
      elementInputStyle,
      name,
      value,
      onChange,
      onClickPlus,
      onClickMinus,
      readOnly,
      subtext,
      maxVal
    } = { ...this.props };
    return (
      <FormGroup className={classes.mainContainer}>
        <FormLabel style={elementLabelStyle} className={classes.formLabel}>{label}</FormLabel>
        <InputGroup  style={elementInputStyle} className={classes.inputGroup}>
          <FormControl
            placeholder={label}
            aria-label="Miles"
            className={classes.inputElement}
            name={name}
            value={value + subtext}
            onChange={onChange}
            readOnly ={readOnly}
          />
          <InputGroup.Append>
            <Button variant="outline-secondary" className={classes.button} onClick={onClickPlus} disabled={(value === 0) ? true : false}>
              {firstBtnLabel}
            </Button>
            <Button variant="outline-secondary" className={classes.button} onClick={onClickMinus} disabled={(value === maxVal) ? true : false}>
              {secondBtnLabel}
            </Button>
          </InputGroup.Append>
        </InputGroup>
      </FormGroup>
    );
  }
}

export default ButtonAddon;
